import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_BED_BANK, OFFER_TYPE_HOTEL, OFFER_TYPE_LAST_MINUTE, OFFER_TYPE_TOUR } from 'constants/offer'
import { DistanceUnit } from '../../Support/searchDistanceLabel'
import { getDepositPropertiesForOffer, getDepositPropertiesForTourV2, getPricingPropertiesForOffer, getPricingPropertiesForTourV2 } from './createYouMayAlsoLikeTileView'
import { TileViewProps } from './types'

interface Params {
    currency: string;
    offerAvailableRates?: App.OfferAvailableRates
    duration?: number
    distance?: number | null
    distanceUnit: DistanceUnit
    distanceFrom?: string
    defaultDepositAmountPercentage: number;
}

export function getTileViewProps(offer: App.Offer | Tours.V2Offer | App.BedbankOffer, params: Params): TileViewProps {
  const { currency, offerAvailableRates, distance, duration } = params
  switch (offer.type) {
    case 'connection_tour':
    case 'direct_tour':
    case 'partner_tour':
      const depositProps = getDepositPropertiesForTourV2(offer, currency)
      const pricing = getPricingPropertiesForTourV2(offer)

      return {
        ...depositProps,
        depositEnabled: depositProps.depositShouldDisplay,
        pricing,
        duration,
      }
    case OFFER_TYPE_BED_BANK:
      return {
        depositEnabled: false,
        distance,
        distanceFrom: params.distanceFrom,
        distanceUnit: params.distanceUnit,
        duration,
      }
    case OFFER_TYPE_TOUR:
    case OFFER_TYPE_ALWAYS_ON:
    case OFFER_TYPE_LAST_MINUTE:
    case OFFER_TYPE_HOTEL: {
      const depositProperties = getDepositPropertiesForOffer(offer, currency, params.defaultDepositAmountPercentage, offerAvailableRates)
      const pricing = getPricingPropertiesForOffer(offer)
      const result = {
        ...depositProperties,
        depositEnabled: depositProperties.depositShown,
        pricing,
        distance,
        distanceFrom: params.distanceFrom,
        distanceUnit: params.distanceUnit,
        duration,
      }
      if (offer.type === OFFER_TYPE_TOUR) {
        delete result.distance
        delete result.distanceFrom
        delete result.distanceUnit
      }
      return result
    }
    default:
      return undefined
  }
}
